// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-1 {
  width: 50vw;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
}
@media (max-width: 1499.98px) {
  .card-1 {
    width: 60vw;
  }
}
@media (max-width: 1199.98px) {
  .card-1 {
    width: 70vw;
  }
}
@media (max-width: 991.98px) {
  .card-1 {
    width: 85vw;
  }
}

.card-result {
  width: 70vw;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
}
.card-result .tab-header-icon {
  font-size: 16px;
}
.card-result .icon-green {
  color: green;
}
.card-result .icon-red {
  color: red;
}
.card-result .tab-content {
  width: 60vw;
}

.search-types {
  max-height: 48vh;
}

.search-types-list {
  height: 310px;
  overflow-y: auto;
}

.search-types-header {
  overflow: hidden;
}

.example-large-box {
  display: grid;
  align-items: center;
  justify-content: center;
}
@media (max-width: 648px) {
  .example-large-box {
    height: auto;
  }
}

.example-large-box-top {
  display: flex;
  justify-content: center;
}

.form-fields-width {
  width: 100%;
  font-size: 15px;
  padding: 0;
}

@media (min-width: 647px) {
  .input-box {
    border-right: 2px #e7e7e7 solid;
  }
}
.input-box .half {
  width: 33.5%;
}
.input-box .altitude {
  width: 26%;
}

input[type=number]::-webkit-outer-spin-button,
input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}

.info-icon {
  vertical-align: middle;
  color: #00677F;
  font-size: 20px;
}

mat-hint {
  color: rgba(0, 0, 0, 0.6);
  font-size: 8pt;
  font-style: italic;
}

::ng-deep .mdc-checkbox {
  top: -4px;
}

::ng-deep .mdc-checkbox label {
  cursor: pointer;
}

.searchTypeName {
  margin-left: -6px;
}

mat-checkbox {
  font-size: 12pt;
  font-family: Roboto, "Helvetica Neue", sans-serif;
}`, "",{"version":3,"sources":["webpack://./src/app/power-search/power-search.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,4EAAA;AACF;AACE;EAJF;IAKI,WAAA;EAEF;AACF;AADE;EAPF;IAQI,WAAA;EAIF;AACF;AAHE;EAVF;IAWI,WAAA;EAMF;AACF;;AAHA;EACE,WAAA;EACA,4EAAA;AAMF;AAJE;EACE,eAAA;AAMJ;AAJE;EACE,YAAA;AAMJ;AAJE;EACE,UAAA;AAMJ;AAHE;EACE,WAAA;AAKJ;;AADA;EACE,gBAAA;AAIF;;AADA;EACE,aAAA;EACA,gBAAA;AAIF;;AADA;EACE,gBAAA;AAIF;;AADA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAIF;AAFE;EALF;IAMI,YAAA;EAKF;AACF;;AAFA;EACE,aAAA;EACA,uBAAA;AAKF;;AAFA;EACE,WAAA;EACA,eAAA;EACA,UAAA;AAKF;;AADE;EADF;IAEI,+BAAA;EAKF;AACF;AAHE;EACE,YAAA;AAKJ;AAFE;EACE,UAAA;AAIJ;;AAAA;;EAEI,wBAAA;EACA,SAAA;AAGJ;;AADA;EACI,0BAAA;AAIJ;;AADA;EACE,sBAAA;EACA,cAAA;EACA,eAAA;AAIF;;AADA;EACE,yBAAA;EACA,cAAA;EACA,kBAAA;AAIF;;AADA;EACE,SAAA;AAIF;;AADA;EACE,eAAA;AAIF;;AADA;EACE,iBAAA;AAIF;;AADA;EACE,eAAA;EACA,iDAAA;AAIF","sourcesContent":[".card-1 {\n  width: 50vw;\n  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);\n\n  @media (max-width: 1499.98px) {\n    width: 60vw;\n  }\n  @media (max-width: 1199.98px) {\n    width: 70vw;\n  }\n  @media (max-width: 991.98px) {\n    width: 85vw;\n  }\n}\n\n.card-result {\n  width: 70vw;\n  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);\n\n  .tab-header-icon {\n    font-size: 16px;\n  }\n  .icon-green {\n    color: green;\n  }\n  .icon-red {\n    color: red;\n  }\n\n  .tab-content {\n    width: 60vw;\n  }\n}\n\n.search-types {\n  max-height: 48vh;\n}\n\n.search-types-list {\n  height: 310px;\n  overflow-y: auto;\n}\n\n.search-types-header {\n  overflow: hidden;\n}\n\n.example-large-box {\n  display: grid;\n  align-items: center;\n  justify-content: center;\n  \n  @media (max-width: 648px) {\n    height: auto;\n  }\n}\n\n.example-large-box-top {\n  display: flex;\n  justify-content: center;\n}\n\n.form-fields-width {\n  width: 100%;\n  font-size: 15px;\n  padding: 0;\n}\n\n.input-box {\n  @media (min-width: 647px) {\n    border-right: 2px #e7e7e7 solid;\n  }\n\n  .half {\n    width: 33.5%;\n  }\n\n  .altitude {\n    width: 26%;\n  }\n}\n\ninput[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\ninput[type=\"number\"] {\n    -moz-appearance: textfield;\n}\n\n.info-icon {\n  vertical-align: middle; \n  color: #00677F; \n  font-size: 20px;\n}\n\nmat-hint {\n  color: rgba(0, 0, 0, 0.6);\n  font-size: 8pt;\n  font-style: italic;\n}\n\n::ng-deep .mdc-checkbox {\n  top: -4px;\n}\n\n::ng-deep .mdc-checkbox label {\n  cursor: pointer;\n}\n\n.searchTypeName {\n  margin-left: -6px;\n}\n\nmat-checkbox {\n  font-size: 12pt;\n  font-family: Roboto, \"Helvetica Neue\", sans-serif;\n}\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
